<template>
  <div class="user_table_father">
    <div class="search">
      <el-form inline="true" :model="queryName" :rules="rules" class="module_from_search">
        <el-form-item label="用户名" prop="name" class="queryHeight">
          <el-input class="queryInput" v-model="queryName" placeholder="请输入内容" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="buttonWidth queryButton" id="query" type="primary" @click="queryUserByCondition">查询
          </el-button>
        </el-form-item>
      </el-form>
      <div>
        <el-button class="buttonWidth" type="primary" @click="addUser">添加</el-button>
      </div>
    </div>
    <el-table
        :data="tableData"
        border
        stripe
        :header-cell-style='headerStyle'
        :row-style="{height:'35px'}"
        :cell-style="{padding:'0px'}"
        class="tableStyle">
      <el-table-column prop="number" width="60" label="序号" align="center">
        <template v-slot="scope">
          <span>{{ (queryVo.pageNum - 1) * queryVo.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="用户名" align="center"></el-table-column>
      <el-table-column prop="expiredTime" label="过期时间" align="center"></el-table-column>
      <el-table-column prop="description" label="用户描述" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" align="center">
        <template v-slot="scope">
          <el-button type="text" @click="editUser(scope.row)">编辑</el-button>
          <!-- <el-button type="text" @click="downloadPlat(scope.row)">下载</el-button> -->
          <el-button type="text" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <center>
      <div class="block">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryVo.pageNum"
            :page-sizes="[10, 20, 30]"
            :page-size="queryVo.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
      </div>
    </center>
  </div>
  <user-add-edit-dialog ref="userAddEditDialog"></user-add-edit-dialog>
</template>
<script>
import userAddEditDialog from "./userAddEditDialog";

export default {
  components: {userAddEditDialog},
  name: 'userManageTable',
  data() {
    return {
      queryName: '',
      queryVo: {
        pageSize: 10,
        pageNum: 1,
        name: ''
      },
      userDetails: {
        id: '',
        name: '',
        password: '',
        oldPassword: '',
        dtExpiredTime: '',
        description: ''
      },
      visibleFlg: 'false',
      headerStyle: {
        'color': '#333333',
        'font-size': '14px',
        'font-weight': '35',
        'text-align': 'center',
        'background-color': '#E3E3E3',
      },
      tableData: [],
      editModule: '',
      total: 10
    }
  },
  mounted() {
    document.getElementsByClassName("el-pagination__jump")[0].childNodes[0].nodeValue = "跳至";
  },
  created() {
    this.queryMessage();
  },
  methods: {
    /**
     * @description 查询用户信息
     */
    queryMessage() {
      this.$api.post(true, "/wx/auth/userManage/queryLoginUser", this.queryVo, res => {
        this.tableData = res.data.content.resultlist;
        this.total = res.data.content.total;
      })
    },
    /**
     * @description 条件查询用户信息
     */
    queryUserByCondition() {
      this.queryVo.name = this.queryName;
      this.queryVo.pageNum = 1;
      this.queryMessage();
      this.$message.success("查询成功");
    },
    /**
     * @description 打开新增用户dialog
     */
    addUser() {
      let add = this.$refs.userAddEditDialog;
      let time = new Date();
      time.setFullYear(time.getFullYear() + 1)
      this.userDetails.dtExpiredTime = time;
      add.form = {...this.userDetails};
      add.visibleFlg = true;
    },
    /**
     * @description 监听分页器容量变化
     */
    handleSizeChange(value) {
      this.queryVo.pageSize = value;
      this.queryVo.pageNum = 1;
      this.queryMessage();
    },
    /**
     * @description 监听分页器页数变化
     */
    handleCurrentChange(value) {
      this.queryVo.pageNum = value;
      this.queryMessage();
    },
    /**
     * @description 编辑用户信息
     */
    editUser(param) {
      let dialog = this.$refs.userAddEditDialog;
      dialog.form = {...param};
      // dialog.alertVersionMessage();
      dialog.title = '编辑用户';
      dialog.editFlg = true;
      dialog.visibleFlg = true;
    },
    /**
     * @description 删除用户信息
     */
    deleteUser(param) {
      this.$confirm('此操作将删除该条信息，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.post(true, "/wx/auth/userManage/deleteLoginUser", param.id, res => {
          if (res.data.statusCode === 'API-COMMON-INF-OK') {
            this.$message.success("删除成功");
          } else {
            this.$message.error(res.statusMessage);
          }
          this.queryMessage();
        })
      })
    }
  }
}
</script>
<style scoped>
.buttonWidth {
  width: 100px;
}

.queryInput {
  width: 200px;
  margin-right: 14px;
}

.queryButton {
  color: black;
  background-color: white;
  border-color: rgb(220 223 230);
}

.queryButton:hover {
  color: rgb(64 158 255);
  border-color: rgb(198 226 255);
  background-color: rgb(236 245 255);
}

.queryButton:active {
  color: rgb(64 158 255);
  border-color: rgb(58 142 230);
  background-color: rgb(236 245 255);
}

.tableStyle {
  width: 100%;
  margin-top: 15px;
}

.block {
  margin-top: 15px;
}
</style>

